export const SearchTimeoutMS = 500;
export const ToastTimeoutMS = 3000;

/**
 * Идентификаторы видов резерва из справочника бэкенда (App\Models\Reserve\ReserveType).
 * Значения зашиты там константами, отдельного эндпоинта под них нет.
 */
export const ReserveTypeIds = {
  // ReserveType::UNIFIED (ЕРК) — должность резерва выбирается после группы должностей
  UNIFIED: 10,
  // ReserveType::JUNIOR_RESERVE — по нему подбираются должности для заявок
  JUNIOR_RESERVE: 11,
};
